import styled from 'styled-components';
import GiftTagIconSvg from '../assets/hotels/home/gifttag.svg';

const GiftTagIcon = styled(GiftTagIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height || '3.2rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default GiftTagIcon;
